/**
 * 권한 관리 Directive
 *
 * @since: 2018-11-07
 * @author: kdydesign.kim
 */

/**
 * 관리자 Level 별 입력 컨트롤 제어
 * v-auth-level
 * v-auth-level="force"
 *
 * @type {{name: string, bind(*, *, *), inserted(*, *, *), update(*, *), componentUpdated(*, *, *): void, unbind(*)}}
 */
const Authority = {
  name: 'auth-level',
  hook: (el, binding, vnode) => {
    try {
      const
        uiData = vnode.context.$store.state.common.common.uiData,
        vm = vnode.componentInstance

      const
        authLevel = uiData.user.level,
        haMode = uiData.ha.mode.toLowerCase() // 'Active-Standby'.replace('-').toLowerCase() // uiData.ha.mode
      if (!(binding.expression !== `'force'` && binding.value !== 'force')) return
      if (haMode === 'stand-alone') {
        if (authLevel !== 1) return
        if (vm) {
          vm.authDisable = true
        } else {
          el.disable = true
          el.disabled = true
        }
        return
      }
      const
        haMember = uiData.ha.mmbr,
        uuid = uiData.system.host_uuid,
        haState = haMember.find(mmbr => mmbr.mmbr_uuid === uuid).state

      if (haState.toLowerCase() === 'backup' && binding.value !== 'haforce') {
        if (vm) {
          vm.authDisable = true
        } else {
          el.disable = true
          el.disabled = true
        }
      } else {
        if (authLevel !== 1) return
        if (vm) {
          vm.authDisable = true
        } else {
          el.disable = true
          el.disabled = true
        }
      }
    } catch (e) {
      const vm = vnode.componentInstance

      if (vm) {
        vm.authDisable = true
      } else {
        el.disable = true
        el.disabled = true
      }
    }
  }
}

export {
  Authority
}
